{
  "name": "ats-front",
  "version": "3.35.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test-headless": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "ng lint",
    "prettier:check": "prettier --config .prettierrc --check \"src/**/*.{ts,css,html}\"",
    "build-ui": "cd projects/ui && npm run build-ui",
    "push": "npm version patch && git push",
    "push-minor": "npm version minor && git push"
  },
  "private": true,
  "dependencies": {
    "-": "^0.0.1",
    "@angular-eslint/schematics": "^18.4.0",
    "@angular/animations": "^21.2.9",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.9",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@angular/service-worker": "^21.2.9",
    "@angularclass/hmr": "^3.0.0",
    "@ctrl/ngx-emoji-mart": "^9.2.0",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "@ostabo/flag-icons": "^8.0.0",
    "@scalar/api-reference": "^1.68.0",
    "@swimlane/ngx-charts": "^23.0.0",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/utils": "^8.12.2",
    "ag-charts-enterprise": "^11.3.0",
    "ag-grid-angular": "^33.3.0",
    "ag-grid-enterprise": "^33.3.0",
    "canvas-confetti": "^1.9.3",
    "chart.js": "^4.2.1",
    "cron-parser": "^5.3.1",
    "cronstrue": "^3.3.0",
    "driver.js": "^1.4.0",
    "echarts": "^5.6.0",
    "jstat": "^1.9.6",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.1.4",
    "lodash": "^4.17.21",
    "marked": "^15.0.12",
    "memoizee": "^0.4.15",
    "monaco-editor": "^0.52.2",
    "ngx-echarts": "^20.0.2",
    "ngx-monaco-editor-v2": "^20.0.0",
    "popstate-direction": "^1.0.0",
    "rxjs": "~7.8.0",
    "save-dev": "^0.0.1-security",
    "ts-node": "^10.9.1",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "vite": "^7.1.1",
    "webpack-dev-server": "^5.2.2",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^18.4.0",
    "@angular-eslint/eslint-plugin": "^18.4.0",
    "@angular-eslint/eslint-plugin-template": "^18.4.0",
    "@angular-eslint/template-parser": "^18.4.0",
    "@angular/build": "^21.2.7",
    "@angular/cli": "~21.2.7",
    "@angular/compiler-cli": "^21.2.9",
    "@schematics/angular": "^15.1.0",
    "@types/canvas-confetti": "^1.9.0",
    "@types/d3": "^7.4.0",
    "@types/d3-scale": "^4.0.3",
    "@types/d3-selection": "^3.0.5",
    "@types/d3-shape": "^3.1.1",
    "@types/jasmine": "~4.3.0",
    "@types/lodash": "^4.14.191",
    "@types/memoizee": "^0.4.9",
    "@types/node": "^20.14.9",
    "@typescript-eslint/eslint-plugin": "^8.12.2",
    "@typescript-eslint/parser": "^8.12.2",
    "cpx": "^1.5.0",
    "dotenv": "^16.0.1",
    "eslint": "^9.33.0",
    "http-server": "^14.1.1",
    "husky": "^8.0.3",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "lint-staged": "^13.2.0",
    "ng-packagr": "^21.2.2",
    "ng-samurai": "^3.0.0",
    "prettier": "^2.8.6",
    "simplebar-angular": "^3.3.0",
    "typescript": "5.9.3",
    "yargs": "^17.7.2"
  },
  "overrides": {
    "ngx-monaco-editor-v2": {
      "@angular/common": "^21.2.9",
      "@angular/core": "^21.2.9"
    },
    "@swimlane/ngx-charts": {
      "@angular/animations": "$@angular/animations",
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/forms": "$@angular/forms",
      "@angular/platform-browser": "$@angular/platform-browser",
      "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic",
      "@angular/cdk": "$@angular/cdk"
    }
  }
}
